export const Entities = {
    NL: 1,
    DE: 2,
    BE: 3,
    EN: 4,
}